import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase.ts';
import { Betolto, HibaUzenet } from '../ui/elemek.tsx';

/** Az iroda kiosztási módja, csak olvasásra (a módosítás a super adminé). */
export default function KiosztasOlvaso({ officeId }: { officeId: string }) {
  const lekeres = useQuery({
    queryKey: ['kiosztas-olvaso', officeId],
    gcTime: 0,
    queryFn: async () => {
      const { data: iroda, error } = await supabase.from('offices').select('kiosztas_mod, kiosztas_vezeto_id').eq('id', officeId).single();
      if (error) throw error;
      if (iroda.kiosztas_mod !== 'vezetohoz') return { vezetohoz: false, vezetoNev: null };
      let vezetoNev: string | null = null;
      if (iroda.kiosztas_vezeto_id) {
        const { data: profil, error: profilHiba } = await supabase.from('profiles').select('nev').eq('user_id', iroda.kiosztas_vezeto_id).maybeSingle();
        if (profilHiba) throw profilHiba;
        vezetoNev = profil?.nev ?? null;
      }
      return { vezetohoz: true, vezetoNev };
    },
  });

  return (
    <section aria-labelledby="kiosztas-olvaso-cim" data-testid="kiosztas-olvaso" className="grid gap-1 rounded-2xl border border-vonal px-5 py-4">
      <h2 id="kiosztas-olvaso-cim" className="sr-only">Kiosztás</h2>
      <HibaUzenet hiba={lekeres.error} />
      {lekeres.isPending && <Betolto />}
      {lekeres.data && (
        <p>
          {lekeres.data.vezetohoz
            ? `Kiosztás: minden új lead ${lekeres.data.vezetoNev ? `${lekeres.data.vezetoNev} irodavezetőhöz` : 'az iroda vezetőihez'} kerül, aki kiosztja a kollégáknak. A beállítást a SocialPro módosítja.`
            : 'Kiosztás: körforgás az aktív értékesítők között.'}
        </p>
      )}
    </section>
  );
}
